require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-agile-cuttings-costs-improving-quality-and-accessing-talent.json") })
        }
      }, "path---blog-agile-cuttings-costs-improving-quality-and-accessing-talent");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-agile-cuttings-costs-improving-quality-and-accessing-talent!./.cache/json/blog-agile-cuttings-costs-improving-quality-and-accessing-talent.json
// module id = 805
// module chunks = 231608221292675